import React, {Component} from 'react'
import LocationEditForm from "./form/edit.component.jsx"
import SideBar from '../common/layout/sidebar.component.jsx'

class LocationNew extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
        }
    }

    componentDidMount() {
        SideBar.activateMenu('account')
    }


    render() {
        return (
            <div>
                <LocationEditForm />
            </div>
        );
    }
}

export default LocationNew


// WEBPACK FOOTER //
// ./src/location/new.component.jsx